<template>
  <div class="fixWindow" v-if="show">
    <div class="fixWindowBox">
      <a href="javascript:;" @click="show = false" class="fixWindowClose iconfont icon-guanbi"></a>
      <div class="fixWindowPad">
        <div class="newsViewHeader">
          <div class="newsViewDate">{{tools.timeFormatSeconds(viewData.create_time*1000,'y')}}.{{tools.timeFormatSeconds(viewData.create_time*1000,'m')}}.{{tools.timeFormatSeconds(viewData.create_time*1000,'d')}}</div>
          <div class="newsViewTitle">{{viewData.title}}</div>
        </div>

        <div class="newsViewMain phoneShow">
          <div v-if="viewData.content_h5" v-html="viewData.content_h5"></div>
          <div v-else v-html="viewData.content_pc"></div>
        </div>
        <div class="newsViewMain pcShow" v-html="viewData.content_pc"></div>
      </div>
    </div>
    <loadingBox v-if="loading" />
  </div>
</template>

<script>
import { articleView } from '@/api/web'
import loadingBox from '@/components/loading.vue'
export default {

  components:{
    loadingBox
  },
  data () {
    return {
      show:false,
      viewData:{},
      loading:false
    }
  },
  updated() {


  },
  mounted() {},

  methods:{
    open(id){
      this.show = true
      this.loading = true
      articleView({article_id:id}).then(res => {
        this.loading = false
        if(res.code == 1){
          this.viewData = res.data
        }
      })


    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/view/about/newsView.vue